import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import {
  DataPlatformDetailedTableData,
  DataPlatformTableEntry,
} from '@/models/dataPlatform';
import { dataPlatformService } from '@/services/dataplatform.service';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DataPlatformDetailModal',
  props: {
    dataPlatform: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  dataPlatform: DataPlatformTableEntry;
};





const data = ref<DataPlatformDetailedTableData[]>([]);

const { t } = useI18n();

onMounted(async () => {
  await loadData();
});

async function loadData() {
  data.value = await dataPlatformService.getDetail(props.dataPlatform.id);
}

function getFailedReadingJobAmount(row: DataPlatformDetailedTableData): number {
  // isDataSourceOk and isDataSinkOk can both be null. We want to leave nulls out,
  // so that's why these booleans are checked with === false explicitly
  return row.jobs.filter((job) => job.isDataSourceOk === false && !job.disabled)
    .length;
}

function getFailedWritingJobAmount(row: DataPlatformDetailedTableData): number {
  // isDataSourceOk and isDataSinkOk can both be null. We want to leave nulls out,
  // so that's why these booleans are checked with === false explicitly
  return row.jobs.filter((job) => job.isDataSinkOk === false && !job.disabled)
    .length;
}

function sortByJobsNumber(
  a: DataPlatformDetailedTableData,
  b: DataPlatformDetailedTableData,
  isAsc: boolean,
) {
  const jobsA = a.jobs ? a.jobs.length : 0;
  const jobsB = b.jobs ? b.jobs.length : 0;
  if (jobsA < jobsB) {
    return isAsc ? -1 : 1;
  } else if (jobsA > jobsB) {
    return isAsc ? 1 : -1;
  }
  return 0;
}

return { __sfc: true,props, emit, data, t, loadData, getFailedReadingJobAmount, getFailedWritingJobAmount, sortByJobsNumber }
}

})